
import { Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import About from './About';
import Empty from './Empty';
import Home from './Home';
import MyProjects from './MyProjects';
import MyCV from './MyCV';

export default class Router extends Component {
  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/projects' element={<MyProjects />} />
          <Route path='/cv' element={<MyCV />} />
          <Route path='/about' element={<About />} />
          <Route path='*' element={<Empty />} />
        </Routes>
      </BrowserRouter>
    );
  }
}
